import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  fetchUsersSuccess,
  fetchUsersFailure,
  fetchRestrictedUsersSuccess,
  fetchRestrictedUsersFailure,
} from './users-dropdown-actions';

export function* doFetchUsers({ payload }) {
  try {
    const results = yield call(callApi, {
      endpoint: `graph/users?searchString=${payload.searchString}`,
    });
    yield put(fetchUsersSuccess({ results, dropdownId: payload.dropdownId }));
  } catch (err) {
    yield put(fetchUsersFailure({ err, dropdownId: payload.dropdownId }));
  }
}

export function* dofetchRestrictedUsers({ payload }) {
  try {
    const results = yield call(callApi, {
      // eslint-disable-next-line max-len
      endpoint: `user/treeSearch?searchString=${payload.searchString}${payload.entityScope ? `&entityScope=${payload.entityScope}` : ''}`,
    });
    yield put(fetchRestrictedUsersSuccess({ results, dropdownId: payload.dropdownId }));
  } catch (err) {
    yield put(fetchRestrictedUsersFailure({ err, dropdownId: payload.dropdownId }));
  }
}

function* watchFetchUsers() {
  yield takeLatest(actionTypes.FETCH_USERS, doFetchUsers);
}

function* watchFetchRestrictedUsers() {
  yield takeLatest(actionTypes.FETCH_RESTRICTED_USERS, dofetchRestrictedUsers);
}

export default [fork(watchFetchUsers), fork(watchFetchRestrictedUsers)];
